// extracted by mini-css-extract-plugin
module.exports = {"modal_title":"styles_modal_title__2ot0A","button__disagree":"styles_button__disagree__LYpRQ","button__agree":"styles_button__agree__85ImH"};